export default uuid => {
  return function($uibModalInstance, $log, ProfileClass, ApiClass) {
    'ngInject';

    const vm = this;
    vm.$onInit = activate;

    const { company_id } = ProfileClass.profileComplete.profile;

    vm.submit = () => {
      const item = vm.formData;

      item.jotFormId = (/[0-9]{15}/.exec(item.jotFormId) || [])[0];

      return ApiClass.companiesIdTypeTypeIdPatch({ manage: true, id: company_id, type: 'forms', type_id: uuid }, item)
        .then(() => {
          $uibModalInstance.close('updated');
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    };

    vm.cancel = () => {
      $uibModalInstance.dismiss('cancel');
    };

    function activate() {
      $log.info('Add JotForm Modal');

      ApiClass.companiesIdTypeTypeIdGet(
        {
          manage: true,
          id: company_id,
          type: 'forms',
          type_id: uuid
        },
        null,
        { queryParams: {} }
      )
        .then(({ data: { item } }) => {
          vm.formData = { ...item };
        })
        .catch(error => {
          if (error.status === 404) {
            vm.patch = false;
            return;
          }
          $log.error(error);
          throw error;
        });
      vm.error = {};
      vm.loaded = true;
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/modals/editJotForm/index.js